module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/sales-channels/sales-channels.component.scss
// module id = ./src/app/routes/sales-channels/sales-channels.component.scss
// module chunks = 9